import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Surgery = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M1.77 42.999c0-.5.401-1.001 1.002-1.001h3.605c.501 0 1.002.4 1.002 1 0 .501-.4 1.002-1.002 1.002H2.772c-.6 0-1.001-.4-1.001-1.001ZM10.684 42.999c0-.5.4-1.001 1.001-1.001h3.605c.5 0 1.002.4 1.002 1 0 .501-.4 1.002-1.002 1.002h-3.605c-.6 0-1.001-.4-1.001-1.001ZM19.496 42.999c0-.5.4-1.001 1.002-1.001h3.605c.5 0 1.001.4 1.001 1 0 .501-.4 1.002-1.001 1.002h-3.605c-.501 0-1.002-.4-1.002-1.001ZM28.409 42.999c0-.5.4-1.001 1.001-1.001h3.606c.5 0 1.001.4 1.001 1 0 .501-.4 1.002-1.001 1.002H29.41c-.5 0-1.001-.4-1.001-1.001ZM37.322 42.999c0-.5.4-1.001 1.001-1.001h3.605c.501 0 1.002.4 1.002 1 0 .501-.4 1.002-1.002 1.002h-3.605c-.6 0-1.001-.4-1.001-1.001ZM41.828 1.051a3.627 3.627 0 0 0-5.107 0L12.486 25.28 1.47 36.19c-.4.4-.5.901-.3 1.402.1.4.5.8 1.102.9 5.507.701 11.216-.6 16.022-3.704.401-.2.601-.8.401-1.3l-1.202-3.004L38.123 9.76l3.705-3.704a3.504 3.504 0 0 0 0-5.006ZM3.974 36.591l9.914-9.91 1.502 3.804v.1l1.102 2.803c-3.806 2.403-8.212 3.504-12.518 3.204Zm12.718-8.109L15.39 25.28 33.717 6.858 36.02 9.16 16.692 28.482ZM40.426 4.655 37.422 7.66l-2.303-2.303 3.004-3.003c.6-.601 1.702-.601 2.303 0 .601.6.601 1.702 0 2.302Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
Surgery.displayName = 'Surgery';
Surgery.defaultProps = {
  'aria-label': 'Surgery'
};
export default Surgery;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Surgery.js
// module id = 3711
// module chunks = 11